import { ComboItem, Response, PaginatedResponse } from "../../../../model";
import { VoucherTemplateEditIn, VoucherTemplateEditOut, VoucherTemplateListOut } from "../../../../model/operaciones";
import ServiceBase from "../../../servicebase";

export default class EmailTemplateService extends ServiceBase {
  getEdit = (data:{ id?: number }) => this.GetFetch<Response<VoucherTemplateEditOut>>('operaciones/vouchertemplate/edit', data);

  combo = (data: { activos?: boolean, includeTodos?: boolean, includeNinguno?: boolean, includeId?: number }) => 
    this.GetFetch<Response<ComboItem[]>>('operaciones/vouchertemplate/combo', data);

  find = (data: { pageIndex?: number, pageSize?: number, sort?: string, id?: number, nombre?: string, esIndividual?: boolean, activo?: boolean }) => 
    this.GetFetch<PaginatedResponse<VoucherTemplateListOut>>('operaciones/vouchertemplate/find', data);

  upsert = (data: VoucherTemplateEditIn) => this.PostFetch<Response<number>>('operaciones/vouchertemplate', data);

  delete = (data:{ id:number, undelete?: boolean}) => this.DeleteFetch<Response<void>>('operaciones/vouchertemplate', data);

  /*
  all = () : Promise<IResponse<IVoucherTemplate[]>> => 
    this.GetFetch<IResponse<IVoucherTemplate[]>>('entity/vouchertemplate/all', {});
*/
  /*
  tipos = {
    all: () : Promise<IResponse<{id:string,label:string}[]>> => 
      this.GetFetch<IResponse<{id:string,label:string}[]>>('entity/vouchertemplate/tipos/all', {})
  }
    */
}
